"use client";

import { useEffect, useState } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { searchPlatform } from "@/lib/search/api";
import { queryKeys } from "@/lib/query-keys";

function useDebouncedValue(value: string, delayMs: number) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}

export function usePlatformSearch(query: string, enabled: boolean) {
  const debounced = useDebouncedValue(query.trim(), 250);
  const ready = enabled && debounced.length >= 2;

  return useQuery({
    queryKey: queryKeys.platformSearch(debounced),
    queryFn: () => searchPlatform(debounced),
    enabled: ready,
    placeholderData: keepPreviousData,
  });
}
